import { render } from "./TaskDetail.vue?vue&type=template&id=1206d678&scoped=true"
import script from "./TaskDetail.vue?vue&type=script&lang=js"
export * from "./TaskDetail.vue?vue&type=script&lang=js"

import "./TaskDetail.vue?vue&type=style&index=0&id=1206d678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1206d678"]])

export default __exports__